




























































import AbpBase from "../../../lib/abpbase"
import {Component, Prop} from "vue-property-decorator"

@Component({
	components: {}
})
export default class PatientInfo extends AbpBase {
	colors = ['#fef4ac', '#0018ba', '#ffc200', '#f32f15', '#cccccc', '#5ab639']
	brushs = [{
		lineWidth: 3
	}, {
		lineWidth: 6
	}, {
		lineWidth: 12
	}]
	context: any = {}
	imgUrl: any = []
	canvasMoveUse = false
	// 存储当前表面状态数组-上一步
	preDrawAry: any = []
	// 存储当前表面状态数组-下一步
	nextDrawAry: any = []
	// 中间数组
	middleAry: any = []
	// 配置参数
	config = {
		lineWidth: 1,
		lineColor: '#f2849e',
		shadowBlur: 2
	}

	get controls() {
		return [{
			icon: '&#xe93c;',
			title: '上一步',
			action: 'prev',
			className: this.preDrawAry.length ? 'active fa fa-reply' : 'fa fa-reply'
		}, {
			icon: '&#xe93e;',
			title: '下一步',
			action: 'next',
			className: this.nextDrawAry.length ? 'active fa fa-share' : 'fa fa-share'
		}, {
			icon: '&#xe696',
			title: '清除',
			action: 'clear',
			className: (this.preDrawAry.length || this.nextDrawAry.length) ? 'active fa fa-trash' : 'fa fa-trash'
		}]
	}

	mounted() {
		// const canvas = document.querySelector('#canvas')
		const canvas: any = this.$refs.canvas
		console.log("canvas", canvas)
		this.context = canvas.getContext('2d')
		console.log("context", this.context)
		this.initDraw()
	}

	isPc() {
		const userAgentInfo = navigator.userAgent
		const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
		let flag = true
		for (let v = 0; v < Agents.length; v++) {
			if (userAgentInfo.indexOf(Agents[v]) > 0) {
				flag = false
				break
			}
		}
		return flag
	}

	removeImg(src: any) {
		this.imgUrl = this.imgUrl.filter((item: any) => item !== src)
	}

	initDraw() {
		const preData = this.context.getImageData(0, 0, 1056, 800)
		// 空绘图表面进栈
		this.middleAry.push(preData)
	}

	// mousedown
	canvasDown(e: any) {
		console.log('canvasDown')
		this.canvasMoveUse = true
		const page:any = document.getElementsByClassName("single-page-con")[0]
		const left:any = document.getElementById("left")
		const canvas: any = this.$refs.canvas
		// client是基于整个页面的坐标
		// offset是cavas距离顶部以及左边的距离
		// console.log("浏览器宽度", document.body.scrollWidth)
		console.log("canvas", canvas.offsetLeft)
		console.log("e", e.clientX, e.clientY)
		console.log("page", page.offsetLeft)
		// console.log("e.target.parentNode", e.target.parentNode.offsetLeft, e.target.parentNode.offsetTop)
		const canvasX = e.clientX - page.offsetLeft - 15 - left.offsetWidth
		const canvasY = e.clientY - page.offsetTop - 15
		this.setCanvasStyle()
		// 清除子路径
		this.context.beginPath()
		this.context.moveTo(canvasX, canvasY)
		console.log('moveTo', canvasX, canvasY)
		document.onmousemove = (event: any) => {

		}
		// 当前绘图表面状态
		const preData = this.context.getImageData(0, 0, 1056, 800)
		// 当前绘图表面进栈
		this.preDrawAry.push(preData)
	}

	canvasMove(e: any) {
		if (this.canvasMoveUse) {
			console.log('canvasMove')
			const page:any = document.getElementsByClassName("single-page-con")[0]
			const left:any = document.getElementById("left")
			const canvas: any = this.$refs.canvas
			console.log("e.clientX", e.clientX)
			let canvasX
			let canvasY
			if (this.isPc()) {
				canvasX = e.clientX - page.offsetLeft - 15 - left.offsetWidth
				canvasY = e.clientY - page.offsetTop - 15
			} else {
				canvasX = e.changedTouches[0].clientX - canvas.offsetLeft
				canvasY = e.changedTouches[0].clientY - canvas.offsetTop
			}
			this.context.lineTo(canvasX, canvasY)
			this.context.stroke()
		}
	}

	beginPath(e: any) {
		const canvas = this.$refs.canvas
		if (e.target !== canvas) {
			console.log('beginPath')
			this.context.beginPath()
		}
	}

	// mouseup
	canvasUp(e: any) {
		console.log('canvasUp')
		const preData = this.context.getImageData(0, 0, 1056, 800)
		if (!this.nextDrawAry.length) {
			// 当前绘图表面进栈
			this.middleAry.push(preData)
		} else {
			this.middleAry = []
			this.middleAry = this.middleAry.concat(this.preDrawAry)
			this.middleAry.push(preData)
			this.nextDrawAry = []
		}
		this.canvasMoveUse = false
	}


	// 设置颜色
	setColor(color: any) {
		this.config.lineColor = color
	}

	// 设置笔刷大小
	setBrush(type: any) {
		this.config.lineWidth = type
	}

	// 操作
	controlCanvas(action: any) {
		switch (action) {
			case 'prev':
				if (this.preDrawAry.length) {
					const popData = this.preDrawAry.pop()
					const midData = this.middleAry[this.preDrawAry.length + 1]
					this.nextDrawAry.push(midData)
					this.context.putImageData(popData, 0, 0)
				}
				break
			case 'next':
				if (this.nextDrawAry.length) {
					const popData = this.nextDrawAry.pop()
					const midData = this.middleAry[this.middleAry.length - this.nextDrawAry.length - 2]
					this.preDrawAry.push(midData)
					this.context.putImageData(popData, 0, 0)
				}
				break
			case 'clear':
				this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height)
				this.preDrawAry = []
				this.nextDrawAry = []
				this.middleAry = [this.middleAry[0]]
				break
		}
	}

	// 生成图片
	getImage() {
		const canvas: any = document.querySelector('#canvas')
		const src = canvas.toDataURL('image/png')
		this.imgUrl.push(src)
	}

	// 设置绘画配置
	setCanvasStyle() {
		this.context.lineWidth = this.config.lineWidth
		this.context.shadowBlur = this.config.shadowBlur
		this.context.shadowColor = this.config.lineColor
		this.context.strokeStyle = this.config.lineColor
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/test/index.vue